var d = Object.defineProperty, n = Object.defineProperties;
var i = Object.getOwnPropertyDescriptors;
var C = Object.getOwnPropertySymbols;
var U = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var R = (E, A, _) => A in E ? d(E, A, { enumerable: !0, configurable: !0, writable: !0, value: _ }) : E[A] = _, N = (E, A) => {
  for (var _ in A || (A = {}))
    U.call(A, _) && R(E, _, A[_]);
  if (C)
    for (var _ of C(A))
      u.call(A, _) && R(E, _, A[_]);
  return E;
}, L = (E, A) => n(E, i(A));
var D = /* @__PURE__ */ ((E) => (E.YES = "YES", E.NOT_AVAILABLE = "NOT_AVAILABLE", E.NO_CONTENT = "NO_CONTENT", E.PLAN_UPGRADE_REQUIRED = "PLAN_UPGRADE_REQUIRED", E.YES_ANONYMOUS_ACCESS = "YES_ANONYMOUS_ACCESS", E))(D || {}), M = /* @__PURE__ */ ((E) => (E.MOVIE = "MOVIE", E.EPISODE = "EPISODE", E.SEASON = "SEASON", E.SHOW = "SHOW", E.LIVE_CHANNEL = "LIVE_CHANNEL", E.LIVE_EVENT = "LIVE_EVENT", E))(M || {}), e = /* @__PURE__ */ ((E) => (E.FREE = "FREE", E.PAID = "PAID", E))(e || {}), c = /* @__PURE__ */ ((E) => (E.MAIN = "MAIN", E.TRAILER = "TRAILER", E.EXTRA = "EXTRA", E.LIVE = "LIVE", E))(c || {}), g = /* @__PURE__ */ ((E) => (E.INTRO = "INTRO", E.CAPTIONS = "CAPTIONS", E.RECAP = "RECAP", E.ADS = "ADS", E))(g || {}), Y = /* @__PURE__ */ ((E) => (E[E.DAY = 1] = "DAY", E[E.WEEK = 7] = "WEEK", E[E.MONTH = 30] = "MONTH", E[E.YEAR = 365] = "YEAR", E))(Y || {}), r = /* @__PURE__ */ ((E) => (E.Payu = "PAYU", E.Stripe = "STRIPE", E.Apple = "APPLE", E.Google = "GOOGLE", E.RAZORPAY = "RAZORPAY", E.Amazon = "AMAZON", E.CCBILL = "CCBILL", E.ROKU = "ROKU", E))(r || {}), V = /* @__PURE__ */ ((E) => (E.USD = "usd", E.PLN = "pln", E))(V || {}), f = /* @__PURE__ */ ((E) => (E.DAY = "day", E.WEEK = "week", E.MONTH = "month", E.YEAR = "year", E))(f || {}), l = /* @__PURE__ */ ((E) => (E.MULTI = "MULTI", E.SINGLE = "SINGLE", E))(l || {}), H = /* @__PURE__ */ ((E) => (E.PERIOD = "PERIOD", E.PERCENTAGE = "PERCENTAGE", E.AMOUNT = "AMOUNT", E))(H || {}), B = /* @__PURE__ */ ((E) => (E.PRE_APPLIED = "PRE_APPLIED", E.COUPON = "COUPON", E))(B || {});
const j = [
  r.Amazon,
  r.Google,
  r.Apple,
  r.ROKU
];
var s = /* @__PURE__ */ ((E) => (E.APPLICATION_READY = "application_ready", E.ACCOUNT_CREATED = "account_created", E.ACCOUNT_UPDATED = "account_updated", E.PLAYER_READY = "player_ready", E.SUBSCRIPTION_CANCELED = "subscription_canceled", E.SUBSCRIPTION_CREATED = "subscription_created", E.SUBSCRIPTION_UPDATED = "subscription_updated", E.TRANSACTION_PAID = "transaction_paid", E.TRANSACTION_REFUNDED = "transaction_refunded", E.VIDEO_BUFFER_END = "video_buffer_end", E.VIDEO_BUFFER_START = "video_buffer_start", E.VIDEO_FAIL = "video_fail", E.VIDEO_PLAYING = "video_playing", E.VIDEO_START = "video_start", E.VIDEO_STOP = "video_stop", E.VIDEO_SEEK = "video_seek", E.APPLICATION_LOGIN = "application_login", E.ITEM_FOCUS = "item_focus", E.ITEM_SELECTED = "item_selected", E.SEARCH = "search", E.PAGE_VIEW = "pageView", E.GLOBAL_CONTEXT = "global_context", E.ITEM_DOWNLOAD_START = "item_download_start", E.ITEM_DOWNLOAD_END = "item_download_end", E.ITEMS_PRESENTED = "items_presented", E.AD_START = "ad_start", E.AD_SKIP = "ad_skip", E.AD_END = "ad_end", E.AD_STOP = "ad_stop", E))(s || {}), p = /* @__PURE__ */ ((E) => (E.USER_CONTEXT = "user_context", E.CLIENT_CONTEXT = "client_context", E.PLAYBACK_CONTEXT = "playback_context", E.ATTRIBUTION_CONTEXT = "attribution_context", E))(p || {}), T = /* @__PURE__ */ ((E) => (E.V100 = "1-0-0", E.V101 = "1-0-1", E.V102 = "1-0-2", E.V110 = "1-1-0", E.V120 = "1-2-0", E.V200 = "2-0-0", E.V210 = "2-1-0", E.V300 = "3-0-0", E.V310 = "3-1-0", E))(T || {}), G = /* @__PURE__ */ ((E) => (E.CONTINUE_WATCHING = "CONTINUE_WATCHING", E.CAROUSEL = "CAROUSEL", E.JUMBOTRON = "JUMBOTRON", E))(G || {}), W = /* @__PURE__ */ ((E) => (E.CONTINUE_WATCHING = "continueWatching", E.COLLECTION = "collection", E.ASSET = "asset", E))(W || {}), $ = /* @__PURE__ */ ((E) => (E[E.SD270 = 270] = "SD270", E[E.SD360 = 360] = "SD360", E[E.SD540 = 540] = "SD540", E[E.HD = 720] = "HD", E[E.FHD = 1080] = "FHD", E[E.UHD = 2160] = "UHD", E))($ || {});
const Z = 20, z = 5, J = ["TIMES_SSO"], Q = 60, q = "no_preference", w = (E, A) => {
  var _;
  return (_ = E == null ? void 0 : E.images) == null ? void 0 : _.find((O) => O.type === A);
}, v = (E, A) => {
  var _;
  return (_ = E == null ? void 0 : E.contents) == null ? void 0 : _.find((O) => O.type === A);
}, y = (E, A) => {
  var _, O;
  return (O = (_ = E == null ? void 0 : E.root) == null ? void 0 : _.images) == null ? void 0 : O.find((I) => I.type === A);
}, k = (E) => E ? [D.YES, D.YES_ANONYMOUS_ACCESS].includes(E) : !1, F = [
  s.APPLICATION_READY,
  s.APPLICATION_LOGIN
], K = [
  s.APPLICATION_READY,
  s.APPLICATION_LOGIN
], EE = (E) => K.includes(E), AE = (E) => F.some(
  (A) => E === A
), _E = (E, A = T.V100) => `iglu:com.laminar/${E}/jsonschema/${A}`, OE = (E) => E.map((A) => ({
  asset_id: A.id,
  asset_name: A.name
})), a = (E, A) => {
  const _ = {};
  for (const O of Array(10).keys())
    O === 9 ? _[`${A}${(O + 1) * 10}`] = `rgba(${E}, 1)` : _[`${A}${(O + 1) * 10}`] = `rgba(${E}, 0.${O + 1})`;
  return _;
}, b = a("255,255,255", "white"), x = a("0,0,0", "black"), X = L(N(N({}, b), x), {
  gray: "#323232",
  gray80: "rgba(50, 50, 50, 0.8)",
  lightGray: "#e7e7e7",
  darkGray: "#141414",
  error: "#ff3d3d"
}), h = /([0-9a-f]{3}){1,2}$/i, o = (E) => h.test(E), t = (E) => o(E) && E.startsWith("#"), IE = (E) => {
  const A = N(N({}, E), X);
  for (const _ in A) {
    const O = _, I = A[O];
    if (Array.isArray(I) && O === "gradient") {
      const P = I.map(
        (S) => t(S) ? S : `#${S}`
      );
      A[O] = P;
      continue;
    }
    typeof I == "string" && o(I) && !t(I) && O !== "gradient" && (A[O] = `#${I}`);
  }
  return A;
};
export {
  M as A,
  c as C,
  H as D,
  j as E,
  g as F,
  f as I,
  Q as M,
  q as N,
  Y as P,
  $ as R,
  T as S,
  s as T,
  D as W,
  e as a,
  r as b,
  V as c,
  l as d,
  B as e,
  p as f,
  G as g,
  W as h,
  Z as i,
  z as j,
  J as k,
  w as l,
  v as m,
  y as n,
  k as o,
  EE as p,
  AE as q,
  OE as r,
  X as s,
  _E as t,
  IE as u
};
//# sourceMappingURL=colors-cfab1b7b.js.map
